// extracted by mini-css-extract-plugin
export default {"table":"dBejrtMq7-","group-heading":"_1rEmdaWFLf","groupHeading":"_1rEmdaWFLf","sub":"XSDfkj3Iyi","not-available":"_7FB08npTEV","notAvailable":"_7FB08npTEV"};